/**
*
* VideoHost
*
*/

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import { VIDEO_CONF_BY_ID, VIDEO_CONF_NONE, VIDEO_CONF_PROVIDERS } from './constants.js';
import messages from './messages.js';
import VideoConfContext from './VideoConfContext.js';

function VideoHost(props) {
  const { className } = props;
  const { provider, setProvider, profile } = useContext(VideoConfContext);
  const intl = useIntl();

  const providerInfo = provider && VIDEO_CONF_BY_ID[provider];

  if (!providerInfo) {
    return (
      <div className={className}>
        {VIDEO_CONF_PROVIDERS.filter((o) => o.id !== VIDEO_CONF_NONE).map((o) => (
          <Button key={o.id} variant="light" onClick={() => setProvider(o.id)} className="me-3 py-1">
            <img src={o.icon} alt={o.label} className="me-2" />
            <FormattedMessage {...messages[o.label]} />
          </Button>
        ))}
      </div>
    );
  }

  const name = intl.formatMessage(messages[providerInfo.label]);
  return (
    <div className={classNames([className, 'd-flex align-items-baseline'])}>
      <img src={providerInfo.icon} alt={providerInfo.label} className="me-2 lower-1" />
      <span className="higher-1" title={profile?.email}>
        <span className="text-nowrap">{name}</span>
        <span className="small text-muted ms-2">
          {profile ? profile.email : <FormattedMessage {...messages.notSignedIn} />}
        </span>
      </span>
      <DeleteButton
        onClick={() => setProvider(VIDEO_CONF_NONE)}
        confirmText={{ ...messages.confirmSignOut, values: { name } }}
        confirmLabel={messages.signOut}
        className="lower-1 py-0"
      />
    </div>
  );
}

VideoHost.propTypes = {
  className: PropTypes.string,
};

export default VideoHost;
